<div [class]="'app-sidebar app-sidebar--collapsed app-sidebar--mini app-sidebar--' + globals.sidebarBackgroundStyle + ' ' + globals.sidebarBackground"
     [ngClass]="{
     'app-sidebar--lighter' : globals.sidebarLighterStyle,
      'app-sidebar--shadow' : globals.sidebarShadow
     }">
    <div class="app-sidebar--header">
        <div class="nav-logo">
            <a routerLink="/dashboard-default" routerLinkActive="active" title="Bamburgh Angular Admin Dashboard with NGX Bootstrap PRO">
                <i>
                    <img alt="Bamburgh Angular Admin Dashboard with NGX Bootstrap PRO" src="assets/images/angular.svg">
                </i>
                <span>Bamburgh</span>
            </a>
        </div>
    </div>

    <div class="app-sidebar--content">
        <perfect-scrollbar [autoPropagation]="true">
            <ul class="sidebar-menu-collapsed">
                <li>
                    <a containerClass="tooltip-secondary" placement="right" routerLink="/dashboard-default" routerLinkActive="active" tooltip="Dashboard" [adaptivePosition]="false" container="body">
                    <span>
                        <i-feather class="line-height-1" name="settings"></i-feather>
                    </span>
                    </a>
                </li>
                <li>
                    <a containerClass="tooltip-secondary" placement="right" routerLink="/applications-calendar" routerLinkActive="active" tooltip="Events calendar" [adaptivePosition]="false" container="body">
                    <span>
                        <i-feather class="line-height-1" name="cloud-drizzle"></i-feather>
                    </span>
                    </a>
                </li>
                <li>
                    <a containerClass="tooltip-secondary" placement="right" routerLink="/applications-chat" routerLinkActive="active" tooltip="Chat" [adaptivePosition]="false" container="body">
                    <span>
                        <i-feather class="line-height-1" name="search"></i-feather>
                    </span>
                    </a>
                </li>
                <li>
                    <a containerClass="tooltip-secondary" placement="right" routerLink="/applications-contacts" routerLinkActive="active" tooltip="Contacts" [adaptivePosition]="false" container="body">
                    <span>
                        <i-feather class="line-height-1" name="grid"></i-feather>
                    </span>
                    </a>
                </li>
                <li>
                    <a containerClass="tooltip-secondary" placement="right" routerLink="/applications-file-manager" routerLinkActive="active" tooltip="File manager" [adaptivePosition]="false" container="body">
                    <span>
                        <i-feather class="line-height-1" name="users"></i-feather>
                    </span>
                    </a>
                </li>
                <li>
                    <a containerClass="tooltip-secondary" placement="right" routerLink="/applications-mail" routerLinkActive="active" tooltip="Mail" [adaptivePosition]="false" container="body">
                    <span>
                        <i-feather class="line-height-1" name="life-buoy"></i-feather>
                    </span>
                    </a>
                </li>
                <li>
                    <a containerClass="tooltip-secondary" placement="right" routerLink="/applications-projects" routerLinkActive="active" tooltip="Projects" [adaptivePosition]="false" container="body">
                    <span>
                        <i-feather class="line-height-1" name="coffee"></i-feather>
                    </span>
                    </a>
                </li>
                <li>
                    <a containerClass="tooltip-secondary" placement="right" routerLink="/applications-survey" routerLinkActive="active" tooltip="Survey" [adaptivePosition]="false" container="body">
                    <span>
                        <i-feather class="line-height-1" name="box"></i-feather>
                    </span>
                    </a>
                </li>
                <li>
                    <a containerClass="tooltip-secondary" placement="right" routerLink="/applications-tasks" routerLinkActive="active" tooltip="Tasks" [adaptivePosition]="false" container="body">
                    <span>
                        <i-feather class="line-height-1" name="briefcase"></i-feather>
                    </span>
                    </a>
                </li>
                <li>
                    <a containerClass="tooltip-secondary" placement="right" routerLink="/applications-tickets" routerLinkActive="active" tooltip="Tickets" [adaptivePosition]="false" container="body">
                    <span>
                        <i-feather class="line-height-1" name="layers"></i-feather>
                    </span>
                    </a>
                </li>
                <li>
                    <a containerClass="tooltip-secondary" placement="right" routerLink="/applications-widgets" routerLinkActive="active" tooltip="App widgets" [adaptivePosition]="false" container="body">
                    <span>
                        <i-feather class="line-height-1" name="bell"></i-feather>
                    </span>
                    </a>
                </li>
            </ul>
            <div class="text-center mb-2">
                <a class="m-1 btn btn-warning p-0 d-inline-block shadow-none text-center font-size-lg d-40 rounded" containerClass="tooltip-secondary" href="javascript:history.back()" placement="right" tooltip="Back to previous page" [adaptivePosition]="false" container="body">
                    <fa-icon [icon]="['fas', 'arrow-left']"></fa-icon>
                </a>
            </div>
        </perfect-scrollbar>
    </div>
</div>

<div (click)="toggleSidebarMobileOpen()" [ngClass]="{'is-active' : globals.toggleSidebarMobile}" class="app-sidebar-overlay"></div>
